export type RectMap = Map<string, DOMRect>;

export const prefersReducedMotion = (): boolean => {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
		return false;
	}
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const measureRects = (keys: readonly string[], refs: Map<string, HTMLElement>): RectMap => {
	const rects: RectMap = new Map();
	for (const key of keys) {
		const el = refs.get(key);
		if (el) {
			rects.set(key, el.getBoundingClientRect());
		}
	}
	return rects;
};

export const buildOrderIndex = (order: readonly string[]): Map<string, number> => {
	const m = new Map<string, number>();
	order.forEach((k, i) => m.set(k, i));
	return m;
};

export const isSameOrderIndex = (
	prev: Map<string, number>,
	next: Map<string, number>,
	order: readonly string[],
): boolean => {
	if (prev.size !== next.size) {
		return false;
	}
	for (const key of order) {
		if (prev.get(key) !== next.get(key)) {
			return false;
		}
	}
	return true;
};
